import $ from 'jquery';
import template from './templates/no_image_msg.hbs';

const $tmpl = $.templates(template);

function ButtonExtend($ctx, selector) {
  this.$elem = $ctx.find(selector);
  this.$html = '';
}

ButtonExtend.prototype = {
  show() {
    this.$elem.show();
  },

  hide() {
    this.$elem.hide();
  },

  getMessageTemplate(endType) {
    this.$html = $tmpl.render({endType});
    return this.$html;
  },

  on(etype, target, callback) {
    this.$elem.on(etype, target, callback);
  }
};

export default ButtonExtend;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/button_extend.js
 **/